import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { MicrosoftPowerBIService } from 'src/lib/services/microsoftPowerBI.service';
import { Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class isPowerBIAuthenticatedGuard implements CanActivate, CanActivateChild {
	constructor(private powerBIService: MicrosoftPowerBIService,
				private router: Router) {}

    canActivate(): boolean | Observable<boolean> {

		if(this.powerBIService.isAuthenticated instanceof Observable)
			return this.powerBIService.isAuthenticated.pipe(tap(isAuthenticated => {
						if(!isAuthenticated)
							this.router.navigate(['/fail/403']);
					}));

		else if(!this.powerBIService.isAuthenticated)
			this.router.navigate(['/fail/403']);

		return this.powerBIService.isAuthenticated;
	}

	canActivateChild(): boolean | Observable<boolean> { return this.canActivate(); }
}